// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-container[data-v-c2ec3596]{position:inherit}.close_button[data-v-c2ec3596]{cursor:pointer;width:40px;height:40px;color:#fff;font-size:40px;position:fixed;top:20px;opacity:.8;right:20px;z-index:2200}.close_button[data-v-c2ec3596]:hover{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
